import { Injectable } from '@angular/core';

@Injectable()
export class BeeFreeService {
	isBeeFree: boolean;
	beeFreeType: string;
	type = {
		html: 'html',
		image: 'image'
	};

	constructor() {
		this.isBeeFree = false;
	}

	setBeeFreeAddon(type) {
		this.isBeeFree = true;
		this.beeFreeType = type;
	}

	isBeeFreeAddon() {
		return this.isBeeFree;
	}

	isBeeFreeHTMLAddon() {
		return this.beeFreeType === this.type.html;
	}

	cancelAddon() {
		window.parent.postMessage(
			{
				action: 'onCancel'
			},
			'*'
		);
	}

	sendMessage(message, type) {
		window.parent.postMessage(
			{
				action: type,
				data: message
			},
			'*'
		);
	}
}
